<oth-card (click)="redirect()" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"
          [headerTemplate]="headerTemplate" class="presentation-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <div class="header">
      <div class="presentation-item-content">
        <img *ngIf="src" [class.logo-under-maintenance]="maintenance" [height]="imgHeight"
             [src]="src"
             alt="logo">
        <p>{{ title }}</p>
      </div>
    </div>

  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <p class="presentation-description">{{ secondaryText }}</p>
      <oth-button [buttonClasses]="['theme-color-border-color', 'theme-color-font-color', 'transparent-button']" class="button" i18n-text="@@learnMore.button"
                  text="Learn more">
      </oth-button>
    </div>
  </ng-template>

  <!-- Body -->
  <ng-template #footerTemplate>
    <div class="footer">
      <p *ngIf="footerText">{{ footerText }}</p>
    </div>
  </ng-template>
</oth-card>
